import {cn} from '@chekin/guestapp-ui-kit';
import {useRef} from 'react';
import {useCurrentLanguage} from 'hooks/useCurrentLanguage';
import LanguageSelection, {
  LanguageSelectionRef,
} from 'components/ModalSheets/LanguageSelection';
import styles from './styles.module.css';

function LanguageButton() {
  const config = useCurrentLanguage();
  const languageSelectionModalRef = useRef<LanguageSelectionRef>(null);
  if (!config) {
    return null;
  }

  return (
    <>
      <button
        className={styles.languageButton}
        onClick={languageSelectionModalRef.current?.open}
        type="button"
        aria-label={`Change language from ${config.label}`}
      >
        <img
          src={config.flag}
          alt={`${config.label} flag`}
          className={cn(
            styles.flagImage,
            'kiosko:w-[48px] kiosko:h-[48px] kiosko:mr-[10px]',
          )}
        />
        <span
          className={cn(styles.languageLabel, 'kiosko:text-kiosko-m kiosko:font-light')}
        >
          {config.label}
        </span>
      </button>
      <LanguageSelection ref={languageSelectionModalRef} />
    </>
  );
}

export {LanguageButton};
